module.exports = __webpack_public_path__ + "static/media/carry.c38e8545.jpg";